function FileModelDirective($compile, $parse) {
    'ngInject';

    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            let model = $parse(attrs.fileModel);
            let modelSetter = model.assign;

            element.bind('change', function() {
                scope.$apply(function() {
                    modelSetter(scope, element[0].files);
                });
            });
        }
    };
}

export default FileModelDirective;



// WEBPACK FOOTER //
// ./client/app/shared/directives/file-model.directive.js